<template>
    <v-text-field
        :model-value="displayValue"
        :label="label"
        :variant="variant"
        :density="density"
        :rules="rules"
        :clearable="clearable"
        :readonly="readonly"
        :hint="hint"
        :persistent-hint="persistentHint"
        :hide-details="hideDetails"
        :append-inner-icon="hasAppendInnerSlot ? undefined : appendInnerIcon"
        autocomplete="off"
        @update:model-value="onInput"
        @click:append-inner="$emit('click:append-inner', $event)"
        @focus="onFocus"
        @blur="onBlur">
        <template v-if="hasAppendInnerSlot" #append-inner>
            <slot name="append-inner" />
        </template>
    </v-text-field>
</template>

<script>
function stripPercent(value) {
    return String(value ?? '').replace(/%/g, '').trim();
}

function formatWithPercent(value) {
    const stripped = stripPercent(value);
    if (!stripped) {
        return '';
    }
    return `${stripped}%`;
}

export default {
    name: 'PercentageTextField',
    props: {
        modelValue: {
            type: [String, Number],
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        variant: {
            type: String,
            default: 'outlined',
        },
        density: {
            type: String,
            default: 'default',
        },
        rules: {
            type: Array,
            default: () => [],
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        hint: {
            type: String,
            default: '',
        },
        persistentHint: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [Boolean, String],
            default: 'auto',
        },
        appendInnerIcon: {
            type: String,
            default: undefined,
        },
    },
    emits: ['update:modelValue', 'click:append-inner', 'blur', 'focus'],
    data() {
        return {
            isFocused: false,
        };
    },
    computed: {
        displayValue() {
            if (this.isFocused) {
                return stripPercent(this.modelValue);
            }
            return formatWithPercent(this.modelValue);
        },
        hasAppendInnerSlot() {
            return Boolean(this.$slots['append-inner']);
        },
    },
    methods: {
        onInput(value) {
            this.$emit('update:modelValue', stripPercent(value));
        },
        onFocus(event) {
            this.isFocused = true;
            this.$emit('focus', event);
        },
        onBlur(event) {
            this.isFocused = false;
            this.$emit('blur', event);
        },
    },
};
</script>
